import { PropTypes } from '@elliemae/ds-legacy-props-helpers';
import { Position } from './positions.js';
import { Interaction } from './interaction.js';

export const popperProps = {
  /** Hide menu component if trigger component is not visible/scrolled away */
  hideIfNotVisible: PropTypes.bool.description('Hide menu component if trigger component is not visible/scrolled away'),
  /** props to inject to popper wrapper */
  containerProps: PropTypes.object.description('props to inject to popper wrapper'),
  /** Space between the arrow and the popup */
  arrowGap: PropTypes.number.description('Space between the arrow and the popup'),
  /** callback for when menu changes from close to open */
  onOpen: PropTypes.func.description('callback for when menu changes from close to open'),
  /** callback for when menu changes from open to close */
  onClose: PropTypes.func.description('callback for when menu changes from open to close'),
  /** Time in ms to delay close of menu */
  delayClose: PropTypes.number.description('Time in ms to delay close of menu'),
  /** Time in ms to delay open of menu */
  delayOpen: PropTypes.number.description('Time in ms to delay open of menu'),
  /** callback for when menu changes placement */
  onPlacementChange: PropTypes.func.description('callback for when menu changes placement'),
  /** Arrow size */
  arrowSize: PropTypes.number.description('Arrow size'),
  /** Bem blockname for the popper */
  blockName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).description('Bem blockname for the popper'),
  triggerComponent: PropTypes.element.description(
    `The component that will open/close the tooltip. 
    Cannot be used with disabled elements. 
    https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/disabled`,
  ).isRequired,
};

export const defaultProps = {
  containerProps: {},
  arrowGap: 8,
  arrowSize: 6,
  blockName: '',
  contentOffset: null,
  contentStyle: null,
  contentComponent: () => null,
  delayClose: 300,
  delayOpen: 200,
  interactionType: Interaction.CLICK,
  onOpen: () => null,
  onClose: () => null,
  onPlacementChange: () => null,
  placement: Position.BOTTOM,
  preventOverflow: 'window',
  showArrow: true,
  closeAnimationConfig: {
    to: { transform: 'scale(0.8)', opacity: '0' },
    config: { delay: 80, duration: 80 },
  },
  openAnimationConfig: {
    to: { transform: 'scale(1)', opacity: '1' },
    config: { delay: 80, duration: 80 },
  },
  usePortal: true,
  triggerComponent: () => null,
  getTargetFromChildren: () => null,
  getContentFromChildren: () => null,
  modifiers: {},
  triggerRef: () => null,
  hideIfNotVisible: false,
};
